import React, { useEffect, useState } from 'react';
import ExoTable from '../ExoTable';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { API_DELETE, API_GET, DBRequest, useConfig } from '../../../api/api';
import useFetch from '../../../api/useFetch';
import DateTimeLabel from '../../label/DateTimeLabel';
import DeleteIcon from '@mui/icons-material/Delete';
import MoneyLabel from '../../label/MoneyLabel';

export const EmployeeClassSelector = ({ onSelect, existingEmpClasses }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const { apiData, setApiData } = useFetch('wage-presets');
  const [tableData, setTableData] = useState(null);

  useEffect(() => {
    if (!apiData) return;

    let newtableData = apiData.data;

    newtableData = newtableData.filter((empClass) => {
      if (
        existingEmpClasses &&
        existingEmpClasses.find((existing) => existing.id == empClass.id)
      )
        return false;
      else return true;
    });

    setTableData({ ...apiData, data: newtableData });
  }, [apiData]);

  const columns = [
    {
      header: t('Title'), // header of column
      key: 'label', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Hourly Rate'),
      key: 'wage',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      //width: "270px",
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">
          <MoneyLabel money={row.wage} />
        </Typography>
      ),
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Last Change'),
      key: 'updatedAt',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      //width: "270px",
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">
          <DateTimeLabel dateTime={row.updatedAt} />
        </Typography>
      ),
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Delete'),
      key: 'delete',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: '100px',
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <IconButton onClick={() => handleDelete(row)}>
          <DeleteIcon />
        </IconButton>
      ),
      //onClick: (row) => handleSelect(row),
    },
  ];

  function handleDelete(row) {
    DBRequest({
      config,
      path: `wage-presets/${row.id}`,
      method: API_DELETE,
      onResponse: () => handleDeleteResponse(row),
    });
  }

  function handleDeleteResponse(row) {
    const newData = tableData.data.filter((el) => el.id != row.id);
    setTableData({ data: newData });
  }

  function handleSelect(row) {
    DBRequest({
      config,
      path: `wage-presets/${row.id}`,
      method: API_GET,
      onResponse: onSelect,
    });
  }

  return (
    <Box className="px-5">
      <Typography className="py-5" variant="h3">
        {t('Load Wage Presets')}
      </Typography>
      <ExoTable data={tableData} columns={columns} />
    </Box>
  );
};
